export default __webpack_public_path__ + "static/earth-241907c37400c8e093755acb9b7821c8.svg";